const gapDataMath = [
  {
    District: 'Menlo Park City Elementary',
    'Difference in performance': 60.76,
    'White students': 82.19,
    'Black students': 21.43,
  },
  {
    District: 'Sequoia Union High',
    'Difference in performance': 56.22,
    'White students': 66.86,
    'Black students': 10.64,
  },
  {
    District: 'Redwood City Elementary',
    'Difference in performance': 56.13,
    'White students': 68.63,
    'Black students': 12.50,
  },
  {
    District: 'Berkeley Unified',
    'Difference in performance': 55.34,
    'White students': 74.07,
    'Black students': 18.73,
  },
  {
    District: 'San Francisco Unified',
    'Difference in performance': 54.71,
    'White students': 63.79,
    'Black students': 9.08,
  },
];

export default gapDataMath;
